import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: "3em",
    height: "3em",
    boxShadow: "0px 0px 10px 1px #b2b2b28f",
    pointerEvents: 'none',
  },
  coverImage: { 
    height: "auto", 
    width: "100%", 
    pointerEvents: 'none',
  },
  root: {
    maxWidth: "800px",
  },
}));
export default useStyles;